module.exports = __webpack_public_path__ + "static/logo-16f974dca28dd6f814e19f37327e1e18.png";